/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Отображение вкладок Мои заказы на главной странице авторизованого пользователя.
   */
  app.TabsSiteIndexOrdersView = app.TabsBaseItemView.extend({
    
    unActiveTabInnerClass: 'link link_pseudo link_white link_on-dark ',
    unActiveContent: 'not_display',
    
    showTab: function ($tab) {
      $tab.addClass(this.activeTabClass);
      $tab.children('span').removeClass(this.unActiveTabInnerClass);
    },
    
    hideTab: function ($tab) {
      $tab.removeClass(this.activeTabClass);
      $tab.children('span').addClass(this.unActiveTabInnerClass);
    },
    
    showContent: function ($content) {
      $content.removeClass(this.unActiveContent);
    },
    
    hideContent: function ($content) {
      $content.addClass(this.unActiveContent);
    }
  });
})();

}.call(window));